export class Estados {
  static getByName(name: string): {name: string, UF: string, cUF: number} {
    for(let val of Estados.values) {
      if(val.name == name)
        return val;
    }
    return null;
  }
  static getByUF(uf: string): {name: string, UF: string, cUF: number} {
    for(let val of Estados.values) {
      if(val.UF == uf)
        return val;
    }
    return null;
  }
  static getByCUF(cUF: number): {name: string, UF: string, cUF: number} {
    for(let val of Estados.values) {
      if(val.cUF == cUF)
        return val;
    }
    return null;
  }

  static values: Array<{name: string, UF: string, cUF: number}> = [{
    name: "Rondônia",
    UF: "RO",
    cUF: 11
  },{
    name: "Acre",
    UF: "AC",
    cUF: 12
  },{
    name: "Amazonas",
    UF: "AM",
    cUF: 13
  },{
    name: "Roraima",
    UF: "RR",
    cUF: 14
  },{
    name: "Pará",
    UF: "PA",
    cUF: 15
  },{
    name: "Amapá",
    UF: "AP",
    cUF: 16
  },{
    name: "Tocantins",
    UF: "TO",
    cUF: 17
  },{
    name: "Maranhão",
    UF: "MA",
    cUF: 21
  },{
    name: "Piauí",
    UF: "PI",
    cUF: 22
  },{
    name: "Ceará",
    UF: "CE",
    cUF: 23
  },{
    name: "Rio Grande do Norte",
    UF: "RN",
    cUF: 24
  },{
    name: "Paraíba",
    UF: "PB",
    cUF: 25
  },{
    name: "Pernambuco",
    UF: "PE",
    cUF: 26
  },{
    name: "Alagoas",
    UF: "AL",
    cUF: 27
  },{
    name: "Sergipe",
    UF: "SE",
    cUF: 28
  },{
    name: "Bahia",
    UF: "BA",
    cUF: 29
  },{
    name: "Minas Gerais",
    UF: "MG",
    cUF: 31
  },{
    name: "Espírito Santo",
    UF: "ES",
    cUF: 32
  },{
    name: "Rio de Janeiro",
    UF: "RJ",
    cUF: 33
  },{
    name: "São Paulo",
    UF: "SP",
    cUF: 35
  },{
    name: "Paraná",
    UF: "PR",
    cUF: 41
  },{
    name: "Santa Catarina",
    UF: "SC",
    cUF: 42
  },{
    name: "Rio Grande do Sul",
    UF: "RS",
    cUF: 43
  },{
    name: "Mato Grosso do Sul",
    UF: "MS",
    cUF: 50
  },{
    name: "Mato Grosso",
    UF: "MT",
    cUF: 51
  },{
    name: "Goiás",
    UF: "GO",
    cUF: 52
  },{
    name: "Distrito Federal",
    UF: "DF",
    cUF: 53
  }]
}